export default __webpack_public_path__ + "static/media/gps.e53e1478.svg";